// extracted by mini-css-extract-plugin
export default {"content":"Identificacao_content__7TN+5","title":"Identificacao_title__UBDA2","buttonContainer":"Identificacao_buttonContainer__02pI6"};